/**
 * Outlet staff designations (roster role on engagement_staff.role).
 */

export const STAFF_ROLE_OPTIONS = [
  { value: 'style_director', label: 'Style Director' },
  { value: 'senior_stylist', label: 'Senior Stylist' },
  { value: 'stylist', label: 'Stylist' },
  { value: 'beauty', label: 'Beauty' },
  { value: 'hair_and_beauty', label: 'Hair & Beauty' },
  { value: 'therapist', label: 'Therapist' },
];

/** @deprecated Use STAFF_ROLE_OPTIONS — kept for callers that still map optgroups */
export const STAFF_ROLE_GROUPS = [{ label: '', options: STAFF_ROLE_OPTIONS }];

const LABEL_BY_VALUE = new Map(STAFF_ROLE_OPTIONS.map((o) => [o.value, o.label]));

const LEGACY_LABELS = {
  lead: 'Lead stylist',
  assistant: 'Assistant',
  color_specialist: 'Color specialist',
  nail_technician: 'Nail technician',
  nail_classic_premium: 'Nail care',
};

export function staffRoleLabel(role) {
  const key = String(role || '').trim().toLowerCase().replace(/\s+/g, '_');
  if (!key) return 'Stylist';
  if (LABEL_BY_VALUE.has(key)) return LABEL_BY_VALUE.get(key);
  if (LEGACY_LABELS[key]) return LEGACY_LABELS[key];
  return String(role)
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

/** Ensure select shows a valid option when editing legacy rows */
export function staffRoleSelectValue(role) {
  const key = String(role || 'stylist').trim().toLowerCase().replace(/\s+/g, '_');
  if (LABEL_BY_VALUE.has(key)) return key;
  return key || 'stylist';
}

export function isKnownStaffRole(role) {
  const key = staffRoleSelectValue(role);
  return LABEL_BY_VALUE.has(key);
}

export const HAIR_STYLIST_TIER_ROLES = [
  'style_director',
  'senior_stylist',
  'stylist',
  'hair_and_beauty',
];

export const SKIN_WELLNESS_ROLES = ['beauty', 'therapist', 'hair_and_beauty'];

export const NAIL_CARE_ROLES = ['beauty', 'therapist', 'hair_and_beauty'];

/** @deprecated Legacy specialist role — maps to hair tier in kiosk filter */
export const COLOR_SPECIALIST_ROLE = 'senior_stylist';
